import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var mapToInternalMenuItems = function mapToInternalMenuItems(parentItemPath, items) {
  return items.map(function (item, index) {
    var _item$SubItems, _item$Icon;
    var itemPath = "".concat(parentItemPath, "/").concat(index, "/");
    var subItems = (_item$SubItems = item.SubItems) !== null && _item$SubItems !== void 0 ? _item$SubItems : [];
    if (subItems.length && item.Url) {
      subItems = [{
        Title: item.Title,
        Url: item.Url
      }].concat(_toConsumableArray(subItems));
    }
    return {
      itemPath: itemPath,
      title: item.Title,
      url: item.Url,
      icon: (_item$Icon = item.Icon) !== null && _item$Icon !== void 0 ? _item$Icon : null,
      subItems: mapToInternalMenuItems(itemPath, subItems)
    };
  });
};